<template>
  <div class="container container--narrow mgt-200" >
      <div class=" t-center mgt-100">
          <img src="images/reward/no-certificate.svg" alt="" class="no-degree-image mgx-auto">
      </div>
      <div class="mgt-24 t-center t-headline8 font-r">
          {{$t('1709')}}
      </div>
      <div class="mgt-4 t-center t-body1 t-color-bodyGrayA">{{$t('1710')}}</div>
  </div>
</template>

<script>
/**
 * 데이터 없음 컴포넌트(no data Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  
};
</script>
<style scoped>
.noDataImage{
    width: 67px;
    height: 64px;
  }
</style>
